import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Landing from './routes/Landing'
import Get from './routes/Get'
import NotFound from './routes/NotFound'
import { usePageviewTracking } from './lib/analytics'

// The two non-marketing routes are code-split so their dependencies leave the
// entry graph: `Destination` pulls gsap (~28KB) plus the ten flipbook trees
// (~18KB), and neither is reachable from `/` or `/get`. The two MARKETING
// routes stay statically imported on purpose - they are where the ad spend
// lands, and a route-chunk round trip before first paint costs more on Indian
// mobile than the bytes it defers.
const Destination = lazy(() => import('./routes/Destination'))
const Kit = lazy(() => import('./routes/Kit'))

export default function App() {
  usePageviewTracking()
  return (
    // `null` rather than a spinner: the only lazy routes are a flipbook player
    // and an internal token sandbox, both of which open on their own loading
    // state anyway.
    <Suspense fallback={null}>
      <Routes>
        <Route path='/' element={<Landing />} />
        {/* Conversion-optimised twin of `/` for Meta paid traffic. The two are
            deliberately independent pages (own CSS root, own CTA placements) so
            different ad sets can be pointed at each and compared. */}
        <Route path='/get' element={<Get />} />
        <Route path='/destinations/:slug' element={<Destination />} />
        <Route path='/_kit' element={<Kit />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
